var Dispatcher = require('flux').Dispatcher;

module.exports = new Dispatcher();



/** WEBPACK FOOTER **
 ** ./src/dispatcher/AppDispatcher.js
 **/